import { z } from 'zod';

/**
 * `GET /voll-wallet/card/processing` — as compras no cartão cujo voucher ainda não foi concluído
 * (as últimas, até 5; `vouchersInProcessing` do wallets-api). `swapAllowed`: o cliente libera
 * trocar a carteira que pagou uma delas (`allowCardPaymentWalletSwap`).
 */
export const VollWalletCardProcessingSchema = z
  .object({
    swapAllowed: z.boolean(),
    purchases: z.array(
      z
        .object({
          voucherId: z.string().min(1),
          /** A carteira que pagou; `null` quando o wallets-api não a nomeia. */
          walletName: z.string().nullable(),
          /** Em reais. */
          amount: z.number(),
        })
        .strict(),
    ),
  })
  .strict();
export type VollWalletCardProcessing = z.infer<typeof VollWalletCardProcessingSchema>;

/** `GET /voll-wallet/card/processing/:voucherId/wallets` — as carteiras do viajante para onde a
 *  compra pode ir (com saldo na data da compra); vazia = nenhuma. */
export const VollWalletSwapWalletsSchema = z
  .object({
    wallets: z.array(
      z
        .object({
          id: z.string().min(1),
          name: z.string(),
          /** O saldo disponível, em reais. */
          available: z.number(),
        })
        .strict(),
    ),
  })
  .strict();
export type VollWalletSwapWallets = z.infer<typeof VollWalletSwapWalletsSchema>;

/** `POST /voll-wallet/card/processing/:voucherId/swap` — move a compra para outra carteira. */
export const VollWalletSwapRequestSchema = z.object({ walletId: z.string().min(1) }).strict();
export type VollWalletSwapRequest = z.infer<typeof VollWalletSwapRequestSchema>;

/** A troca feita: o movimento novo, na carteira escolhida. */
export const VollWalletSwapResponseSchema = z.object({ movementId: z.string().min(1) }).strict();
export type VollWalletSwapResponse = z.infer<typeof VollWalletSwapResponseSchema>;

/**
 * As recusas da troca. 409: `swap_not_allowed` (o cliente não libera), `voucher_concluded` (a
 * compra já foi concluída), `wallet_not_eligible` (a carteira não é do viajante, não tem saldo
 * ou é a mesma), `swap_in_progress` (outra troca da mesma compra está em curso). 422
 * `swap_failed`: o wallets-api recusou e nada mudou. 502 `outcome_unknown`: a troca pode ter
 * acontecido — a tela relê a lista antes de deixar tentar de novo.
 */
export const VollWalletSwapErrorSchema = z
  .object({
    error: z.enum([
      'swap_not_allowed',
      'voucher_concluded',
      'wallet_not_eligible',
      'swap_in_progress',
      'swap_failed',
      'outcome_unknown',
    ]),
  })
  .strict();
export type VollWalletSwapError = z.infer<typeof VollWalletSwapErrorSchema>;
